<div class="body">
    <br />
    <div class="container principal">
        <div class="col-lg-12">
            <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben
                    conservar los originales de los documentos </b>
                <br />
                <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5
                    años</b>
                <br />
                <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b> Dictamen N° 467/2021.
                <br />
                <br />
                La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual
                <br />
                conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario
                administrativo.
                <br />
            </p>
            <p><b>Manual de subsidio de catastrofe: </b> <a href="{{this.linkTexto}}" target="_blank">
                Catastrofe</a>.</p>
        </div>
    </div>
    <br />
    <div class="row">

        <div class="col-lg-5"> </div>

        <div class="center">
            <h1> Subsidio Catástrofe </h1>
        </div>

        <div class="col-lg-4"> </div>

    </div>
    <br />
    <form #catastrofeForm=ngForm>
        <div class="container principal">

            <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

                <div class="row">

                    <div class="col-lg-8"> </div>

                    <div class="col-lg-4">
                        <p> <b> Usuario: </b> {{nombreUsuario}} </p>
                    </div>
                </div>

            </div>



            <div *ngIf="rol != 'ROLE_AFILIADO'" style="padding-bottom: 20px;">

                <div class="row">

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-2">
                        <h2> Rut Afiliado </h2>
                    </div>

                    <div class="col-lg-4">

                        <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado"
                            #rutAfiliado="ngModel" class="form-control" type="text" required
                            placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1"
                            pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                    </div>

                    <div class="col-lg-1"> </div>

                    <div class="col-lg-1">

                        <button class="btn btn-primary" id="btnvalida"
                            (click)="buscaRegistroCivil(buscador.rutAfiliado,3)" [disabled]="rutAfiliado.invalid">
                            Buscar
                        </button>

                    </div>

                    <div class="col-lg-1"> </div>

                </div>
                <div class="row">

                    <div class="col-lg-5"> </div>

                    <div class="col-lg-5">
                        <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                        </h2>
                    </div>

                </div>
            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-8">
                    <h2> Vivienda Principal </h2>
                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label> Domicilio </label> </div>
                <div class="col-lg-5">
                    <input id="domicilioCatastrofe" name="domicilioCatastrofe" #nombres="ngModel"
                        [(ngModel)]="catastrofe.domicilioCatastrofe" class="form-control" required type="text"
                        placeholder="Ingrese su dirección" />
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />
            <div class="row">
                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Región </label> </div>

                <div class="col-lg-5">

                    <mat-select class="form-control" name="region" #region="ngModel" [(ngModel)]="catastrofe.region"
                        (selectionChange)="traeComunas()" required>
                        <mat-option value="0">
                            SELECCIONE....
                        </mat-option>
                        <mat-option *ngFor="let region of regiones" value="{{region.id}}">
                            {{region.nombre}}
                        </mat-option>

                    </mat-select>
                </div>

            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3"> <label> Ciudad </label> </div>

                <div class="col-lg-5">

                    <mat-select class="form-control" name="comuna" #comuna="ngModel" [(ngModel)]="catastrofe.comuna"
                        required>
                        <mat-option value="0">
                            SELECCIONE....
                        </mat-option>
                        <mat-option *ngFor="let comuna of comunas" value="{{comuna.id}}">

                            {{comuna.nombre}}

                        </mat-option>

                    </mat-select>
                </div>

            </div>

            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-8">
                    <h2> Datos Catástrofe </h2>
                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Fecha Catástrofe </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" id="fechaCatastrofe" name="fechaCatastrofe" #fechaCatastrofe="ngModel"
                        [(ngModel)]="catastrofe.fechaCatastrofe" required type="date">

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <label> Tipo Catástrofe </label>
                </div>

                <div class="col-lg-6">
                    <mat-select class="form-control" name="tipoCatastrofe" #tipoCatastrofe="ngModel"
                        (selectionChange)="muetraOtros()" [(ngModel)]="catastrofe.tipoCatastrofe" required>

                        <mat-option value="0">
                            SELECCIONE....
                        </mat-option>
                        <mat-option *ngFor="let tipo of this.tipos" value="{{tipo.id}}">
                            {{tipo.descripcion}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="col-lg-2"> </div>
            </div>
            <br />
            <div class="row" *ngIf="otro == true">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label> Otro tipo catastrofe </label> </div>
                <div class="col-lg-5">
                    <input id="otroTipoCatastrofe" name="otroTipoCatastrofe" #nombres="ngModel"
                        [(ngModel)]="catastrofe.otroTipoCatastrofe" class="form-control" required type="text"
                        placeholder="Ingrese otro tipo de catastrofe" />
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />

            <div class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest"
                        (change)="seleccionaArchivo($event, 0)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"> </div>

            </div>
            <br />
            <div *ngIf="cantidadArchivos > 1" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (2) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo2"
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest2"
                        (change)="seleccionaArchivo($event, 1)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />
            <div *ngIf="cantidadArchivos > 2" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (3) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo3" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest3"
                        (change)="seleccionaArchivo($event, 2)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />
            <div *ngIf="cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (4) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo4" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest4"
                        (change)="seleccionaArchivo($event, 3)">

                </div>
                <div class="col-lg-1"> </div>
                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <br />
            <div *ngIf="cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest5"
                        (change)="seleccionaArchivo($event, 4)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

            <br />
            <div *ngIf="cantidadArchivos > 5" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (6) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo6" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="catastrofe.archivoTest6"
                        (change)="seleccionaArchivo($event, 5)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />


            <div class="row line">

                <div class="col-lg-2 col-sm-2"> </div>

                <div class="col-lg-6 col-sm-1"> </div>

                <div class="col-lg-3 col-sm-1">
                    <!-- <div *ngIf="rol != 'ROLE_EJECUTIVO_CAIP'"> -->
                    <div
                        *ngIf="rol != 'ROLE_ENCARGADO_NACIONAL' && rol != 'ROLE_EJECUTIVO' && rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class="btn btn-success " (click)="solicitar(catastrofeForm)">
                            Solicitar
                        </button>

                    </div>
                </div>

                <div class="col-lg-1 col-sm-1"> </div>

            </div>

        </div>
    </form>
    <div class="container" style="height:100px"> </div>

</div>